import { useMutation } from "react-query";
import { queryClient } from "services/queries";
import { postEditAddress } from "../requests/Addresses";
import { API_SHOPPING_BAG_QUERY_KEY } from "../queries/useQueryShoppingBag";

export function useMutationEditAddress() {
    const query = useMutation(postEditAddress, {
        onSuccess: (data) => {
            if(data?.success) {
                // console.log(data)
                queryClient.invalidateQueries('apiQueryAddresses')
                queryClient.invalidateQueries(API_SHOPPING_BAG_QUERY_KEY)
            } else {
                // console.log(data?.errors)
            }
        }, onError: (data) => {
            // console.error(data)
        }
    });
    return query;
}
